import React from 'react';
import { useTranslation } from 'react-i18next';
import { styled } from 'styled-components';
import SvgError from '../../../../play-core/icons/Error';
import { Colors } from '../../../../play-core/styles/Colors';
import { Fonts } from '../../../../play-core/styles/Fonts';
import { IconWrapper } from '../../components/IconWrapper/IconWrapper';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const LbwError = () => {
  const {
    t
  } = useTranslation();
  return /*#__PURE__*/_jsxs(Layout, {
    children: [/*#__PURE__*/_jsx(IconWrapper, {
      icon: /*#__PURE__*/_jsx(SvgError, {}),
      size: 40
    }), /*#__PURE__*/_jsx(Text, {
      children: t('global.unableToLoadPlayer')
    })]
  });
};
const Layout = styled.div.withConfig({
  displayName: "LbwError__Layout",
  componentId: "sc-1xk7rxd-0"
})(["width:100%;height:100%;display:flex;flex-direction:column;align-items:center;justify-content:center;color:", ";"], Colors.WHITE);
const Text = styled.span.withConfig({
  displayName: "LbwError__Text",
  componentId: "sc-1xk7rxd-1"
})(["max-width:400px;margin-top:20px;", ";"], Fonts.regular(18));